import React, { Component, PropTypes } from 'react';
import { ProfilePage } from '../../../components/dashboard';
import DataProvider from '../dataProvider';
import { DashboardProfileTab, DashboardNoCurrentLeases } from '../components';
import DetailsSidePanel from './DetailsSidePanel';
import * as routes from '../../../routes/const';
import {
  VEHICLE,
  DRIVER_SUGGESTIONS,
  VEHICLE_SUGGESTIONS,
  REPORT_HEADING,
  CARD_FLAG,
  REPORT_FLAG,
  LEASE_INFORMATION,
  VEHICLE_INFORMATION
} from '../content';

import {
  transformTabs,
  transformDriverDetailsForSidePanel,
  transformLeaseDetailsForSidePanel
} from '../helpers';

class DashboardProfile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: 0, // just a standby will be removed
      selectedTab:
        this.props.profile.CurrentLeases && this.props.profile.CurrentLeases[0],
      openDetails: false,
      closeDetails: true
    };

    this.openDetails = this.openDetails.bind(this);
    this.openCardDetails = this.openCardDetails.bind(this);
    this.fetchDetails = this.fetchDetails.bind(this);
    this.handleTabChange = this.handleTabChange.bind(this);
  }

  // called whenever we change the tabs in the profile pages.
  handleTabChange = object => {
    // When ever the active tab is changed rerender the transformed tabs.
    // need to optimise this , think of way to make this static
    const tabs = this.getTabData(null, object);

    this.setState({
      tabs,
      selectedTab: object
    });
  };

  // called when we click in any of the report cards /charts within the profile.
  openDetails = params => {
    const { profile } = this.props;
    this.setState({
      openDetails: true,
      closeDetails: false
    });
    this.fetchDetails(params, REPORT_FLAG);
  };

  // dynamically fetch the card/report details
  fetchDetails = (obj, flag) => {
    switch (flag) {
      case REPORT_FLAG:
        this.props.actions.fetchReportDetail(obj);
        break;
      case CARD_FLAG:
        this.props.actions.fetchCardDetails(obj);
        break;
    }
  };

  // called when click of the cards in the profile pages
  openCardDetails = params => {
    const { profile } = this.props;
    console.log(params);

    let leaseId, companyCode, countryCode, driverId;

    if (this.props.location.state.dashboardType === 'driver') {
      leaseId = this.state.selectedTab.leaseId;
      companyCode = this.state.selectedTab.CompanyCode;
      (countryCode = profile.CountryCode), (driverId = profile.DriverId);
    } else if (this.props.location.state.dashboardType === 'vehicle') {
      leaseId = profile.LeaseId;
      companyCode = profile.CompanyCode;
      (countryCode = profile.CountryCode),
        (driverId = profile.CurrentDriver.DriverId);
    }

    const obj = Object.assign(params, {
      leaseId,
      companyCode,
      countryCode,
      driverId
    });

    this.setState({
      openDetails: true,
      closeDetails: false,
      params: obj
    });

    this.fetchDetails(obj, CARD_FLAG);
  };

  closeDetails = () => {
    this.setState({
      closeDetails: true,
      openDetails: false,
      detailsType: ''
    });
  };

  navigate = route => {
    const { profile } = this.props;
    const country = {
      value: profile.CountryCode,
      label: profile.CountryName
    };

    const costcenter = {
      value: this.state.selectedTab.CompanyCode,
      label: this.state.selectedTab.CompanyName
    };
    this.props.actions.setCountryConstCenterInsights([country, costcenter]);
    this.context.router.push({
      pathname: route
    });
  };

  fetchProfile = (id, dashboardType) => {
    // pass current roleId. If not available the api fetches details of default role id
    const fetchParams = sessionStorage.getItem('roleId')
      ? { roleId: sessionStorage.getItem('roleId') }
      : {};

    fetchParams.countryCode = this.props.params.countryCode;
    // Api call to fecth driver profile
    this.props.actions.fetchProfile(fetchParams, id, dashboardType);

    this.setState({
      id
    });
  };

  handleAllocation = () => {
    const {
      DriverId,
      DriverFirstName,
      DriverSurname,
      CompanyCode,
      CountryCode,
      CountryName,
      CompanyName
    } = this.props.profile;

    const routerState =
      this.props.location.state.dashboardType === 'driver'
        ? {
            driverProfile: {
              DriverId,
              DriverFirstName,
              DriverSurname,
              CompanyCode,
              CountryCode,
              CountryName,
              CompanyName
            }
          }
        : {
            vehicleAllocationData: this.props.profile
          };

    this.context.router.push({
      pathname: routes.TRANSFERS_DRIVER,
      state: routerState
    });
  };

  showHistoryDetails = () => {
    this.setState({
      closeDetails: false,
      openDetails: true
    });

    const { LeaseId, CurrentLeases, PastLeases, history } = this.props.profile;

    if (this.props.location.state.dashboardType === 'driver') {
      const sidePanelDetails = transformLeaseDetailsForSidePanel(
        CurrentLeases,
        PastLeases,
        this.closeDetails
      );
      this.props.actions.setVehicleHistoryDetails(sidePanelDetails);
      return;
    }

    // No history data yet, need to fetch
    if (!history || !history.length) {
      // Driver history has own API
      this.props.actions.fetchVehicleHistoryDetails(LeaseId).then(res => {
        const driverList = res.value.data;
        const sidePanelDetails = transformDriverDetailsForSidePanel(
          driverList,
          this.closeDetails,
          this.handleAllocation
        );
        this.props.actions.setVehicleHistoryDetails(sidePanelDetails);
      });

      return;
    }

    const sidePanelDetails = transformDriverDetailsForSidePanel(
      history,
      this.closeDetails,
      this.handleAllocation
    );
    this.props.actions.setVehicleHistoryDetails(sidePanelDetails);
  };

  getTabData = (newProps, selected) => {
    const props = newProps || this.props;

    const dashboardType = props.location.state.dashboardType;

    if (dashboardType === 'driver') {
      // TODO -- NO SUGGESTIONS IN THE RESPONSE FOR NOW MANUALLY PUSH

      // Concat the original array to avoid store mutation
      // Sri - comment out DRIVER SUGGESTIONS FOR NOW
      // const driverTabs = props.profile.CurrentLeases.concat([{
      // 	value: DRIVER_SUGGESTIONS,
      // 	key: DRIVER_SUGGESTIONS,
      // 	type: DRIVER_SUGGESTIONS
      // }]);

      const driverTabs = props.profile.CurrentLeases;

      // const selectedTab = selected || {
      // 	key: driverTabs[0].LeaseId
      // };

      let selectedTab;

      if (selected) {
        selectedTab = selected;
      } else if (driverTabs[0]) {
        selectedTab = {
          key: `${driverTabs[0].LeaseId}`
        };
      } else {
        // return an Dummy key tabs array so that hideTabs check is called  during the render
        return [
          {
            key: '0'
          }
        ];
      }

      return transformTabs(driverTabs, selectedTab);
    }

    if (dashboardType === 'vehicle') {
      const vehicleTabs = [
        {
          value: LEASE_INFORMATION,
          key: `${LEASE_INFORMATION}`,
          type: LEASE_INFORMATION
        } /* COMMENT OUT VEHICLE SUGGESTIONS FOR NOW,
				{
					value: VEHICLE_SUGGESTIONS,
					key: VEHICLE_SUGGESTIONS,
					type: VEHICLE_SUGGESTIONS
				} */
      ];

      const selectedTab = selected || {
        key: `${LEASE_INFORMATION}`
      };

      return transformTabs(vehicleTabs, selectedTab);
    }

    return null;
  };

  componentDidMount() {
    console.log('cdm dash profile', this.props.params);
    // if (this.props.location && this.props.location.state)
    //   this.fetchProfile(
    //     this.props.location.state.id,
    //     this.props.location.state.dashboardType
    //   );

    this.fetchProfile(this.props.params.refid, this.props.params.dashtype);
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.location.state.id &&
      (this.props.location.state.id !== nextProps.location.state.id ||
        this.props.location.state.dashboardType !==
          nextProps.location.state.dashboardType)
    ) {
      this.fetchProfile(
        nextProps.location.state.id,
        nextProps.location.state.dashboardType
      );
      return;
    }

    // Exit if current lease hasn't changed
    const isDriverDashboard =
      nextProps.location.state.dashboardType === 'driver';
    if (
      isDriverDashboard &&
      (!this.props.profile ||
        this.props.profile.CurrentLeases === nextProps.profile.CurrentLeases)
    ) {
      return;
    }

    const tabs = this.getTabData(nextProps);
    if (tabs && tabs.length > 0) {
      const selectedTab = tabs[0];

      // Make the call to the API here to fetch the driver details.
      this.setState({
        tabs,
        selectedTab
      });
    }
  }

  render() {
    const { actions, profile } = this.props;
    const { tabs, selectedTab } = this.state;
    const { fetchingProfile } = profile;

    let leaseId,
      selectedKey,
      companyCode,
      leaseData,
      driverId,
      reportHeading,
      hideTabs,
      reportCards;

    if (fetchingProfile || !selectedTab) {
      return <div />;
    }

    if (this.props.location.state.dashboardType === 'driver') {
      leaseId = selectedTab.leaseId;
      selectedKey = selectedTab.key;
      leaseData = selectedTab.leaseData;
      companyCode = selectedTab.CompanyCode;
      driverId = profile.DriverId;
      reportHeading = REPORT_HEADING;
      reportCards = profile.ReportCards;
      hideTabs =
        !profile || !profile.CurrentLeases || !profile.CurrentLeases.length;
    } else if (this.props.location.state.dashboardType === 'vehicle') {
      leaseId = profile.LeaseId;
      selectedKey = selectedTab.key;
      leaseData = {
        driverName: profile.CurrentDriver
          ? `${profile.CurrentDriver.DriverFirstName} ${profile.CurrentDriver.DriverSurname}`
          : null
      };
      companyCode = profile.CompanyCode;
      driverId = profile.CurrentDriver ? profile.CurrentDriver.DriverId : null;
      reportHeading = VEHICLE_INFORMATION;

      reportCards = profile.VehicleInfoCards;
      hideTabs = !profile || !profile.CurrentDriver;
    }

    // So as to prevent the intial render of the page withour tabs being loaded
    return (
      <div>
        {tabs && !profile.fetchingProfile && (
          <ProfilePage
            tabs={tabs}
            hideTabs={hideTabs}
            tabValue={selectedTab.key}
            handleTabChange={this.handleTabChange}
            fetchingTabs={fetchingProfile}
          >
            {!hideTabs ? (
              <DashboardProfileTab
                cards={profile.ProfileCards}
                leaseId={leaseId}
                leaseData={leaseData}
                tabValue={selectedKey}
                onCardClick={this.openCardDetails}
                companyCode={companyCode}
                countryCode={profile.CountryCode}
                driverId={driverId}
                reportCards={reportCards}
                openReportDetails={this.openDetails}
                onNavigate={this.navigate}
                showHistoryDetails={this.showHistoryDetails}
                reportHeading={reportHeading}
                dashboardType={this.props.location.state.dashboardType}
              />
            ) : (
              <DashboardNoCurrentLeases
                handleAllocation={this.handleAllocation}
                showHistoryDetails={this.showHistoryDetails}
                dashboardType={this.props.location.state.dashboardType}
              />
            )}

            <DetailsSidePanel
              close={this.closeDetails}
              open={this.state.openDetails}
              detail={profile.detail}
              fetchingDetail={profile.fetchingDetail}
              detailsType={this.state.detailsType}
            />
          </ProfilePage>
        )}
      </div>
    );
  }
}
DashboardProfile.propTypes = {
  actions: PropTypes.shape({}),
  profile: PropTypes.object,
  location: PropTypes.object
};

DashboardProfile.contextTypes = {
  router: PropTypes.object
};

export default DataProvider(DashboardProfile);



// WEBPACK FOOTER //
// ./src/features/dashboard/containers/DashboardProfile.js